<template>
  <div class="absolute w-screen h-screen overflow-hidden z-[10000] bg-neutral-800">
    <div class="w-full h-full flex flex-col overflow-y-auto">
      <div class="h-[44px] md:h-[72px] mx-4 my-10 md:my-6 px-2 md:px-7 flex flex-row justify-between items-center">
        <div>
          <Logo class="h-10 [pointer-events:bounding-box] [&_g]:transition-[fill] [&_g]:duration-300 hover:[&_g]:[fill:#33cccc]" />
        </div>
        <VaButton color="white" round class="w-[44px] h-[44px]" @click="userStore.hideSidebar">
          <VaIcon name="close" size="28px" color="primary" />
        </VaButton>
      </div>

      <div v-if="userStore.isLoggedIn && breakpoints.smaller('md').value" class="p-4 place-self-end">
        <AccountSwitcher />
      </div>

      <div class="p-4 place-self-end">
        <VaMenuList>
          <RouterLink
            v-for="item in menuItems" :key="item.textKey"
            :to="item.route" @click="userStore.hideSidebar"
          >
            <VaMenuItem class="text-2xl text-white">
              <div class="w-full text-right">
                {{ t(item.textKey) }}
              </div>
            </VaMenuItem>
          </RouterLink>
        </VaMenuList>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VaButton, VaIcon, VaMenuItem, VaMenuList } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import Logo from '@/assets/images/logo.svg'
import { useUserStore } from '@/stores/UserStore'
import { computed } from 'vue'
import AccountSwitcher from '@/components/AccountSwitcher.vue'
import { breakpointsTailwind, onKeyStroke, useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints(breakpointsTailwind)
const userStore = useUserStore()
const { t } = useI18n()

onKeyStroke('Escape', () => userStore.hideSidebar())

const menuItems = computed(() => {
  if (!userStore.isLoggedIn) {
    return [
      { textKey: 'menu.login', route: { name: 'login' } },
      { textKey: 'menu.register', route: { name: 'start' } },
    ]
  }

  // if (userStore.user?.role === 'ads') {
    return [
      { textKey: 'menu.dashboard', route: { name: 'dashboard' } },
    { textKey: 'menu.campaigns', route: { name: 'campaign.list' } },
      { textKey: 'menu.createCampaign', route: { name: 'campaign.create' } },
      { textKey: 'menu.assets', route: { name: 'asset.list' } },
      { textKey: 'menu.settings', route: { name: 'account.settings' } },
      { textKey: 'menu.logout', route: { name: 'logout' } },
    ]
  // }

  return [
    { textKey: 'menu.logout', route: { name: 'logout' } },
  ]
})
</script>
